import DOMPurify from 'dompurify';

// Whitelist matching the backend's bleach config so no untrusted content ever renders.
const CONFIG = {
  ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u', 'br', 'p', 'ul', 'ol', 'li', 'a', 'h2', 'h3', 'blockquote'],
  ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
};

// Force safe link handling on all <a> tags in sanitised HTML
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
});

export function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  // Normalise WordPress-imported non-breaking spaces to regular spaces so
  // paragraphs wrap naturally (bios were scraped with &nbsp; between every word).
  const normalised = html.replace(/&nbsp;/g, ' ').replace(/\u00a0/g, ' ');
  return DOMPurify.sanitize(normalised, CONFIG);
}
